import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { BranchingElbowConnector } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/branching-elbow-connector';
import { LensBoxMode, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { taxonomyLensLayout } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/common/layout';
import { useTaxonomyLensContext } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/common/use-taxonomy-lens-context';
import { mean } from 'd3-array';
import { max } from 'lodash';
import { useCarouselLayout } from '../../../impact-lens-profile/context';

export function TaxonomyInfoBoxConnectors() {
  const ctx = useTaxonomyLensContext();
  if (!ctx || !ctx.data.taxonomyKpis) {
    return <></>;
  }
  return (
    <>
      <InfoBoxConnectors />
    </>
  );
}
function InfoBoxConnectors() {
  const ctx = useTaxonomyLensContext();
  const baseLayout = useCarouselLayout();
  const kpis = ctx?.data.taxonomyKpis;
  if (!kpis) {
    return <></>;
  }
  const layout = taxonomyLensLayout(baseLayout, kpis);
  if (baseLayout.boxMode !== LensBoxMode.SIDE) {
    return <></>;
  }
  const boxArea = layout.infoBoxArea();
  const impacts = [
    ImpactCategoryId.GHG_EMISSIONS,
    ImpactCategoryId.NON_GHG_EMISSIONS,
    ImpactCategoryId.BIODIVERSITY,
    ImpactCategoryId.WASTE,
    ImpactCategoryId.SCARCE_NATURAL_RESOURCES,
  ];
  const endPoints = impacts.map(impact => {
    const area = layout.impactEuTaxonomyIndicatorBoxesArea(Side.RIGHT, impact);
    return {
      x: area.x2,
      y: area.y1 + area.height / 2,
    };
  });
  const startPoint = {
    x: boxArea.x1,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    y: mean(endPoints.map(p => p.y))!,
  };

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const branchX = max(endPoints.map(p => p.x))! + 20;

  return <BranchingElbowConnector startPoint={startPoint} endPoints={endPoints} branchX={branchX} />;
}
